"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.App = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _reactRedux = require("react-redux");

var _MapPanel = _interopRequireDefault(require("./containers/MapPanel"));

var _InfoBox = _interopRequireDefault(require("./containers/InfoBox"));

var _MenuHeader = _interopRequireDefault(require("./containers/MenuHeader"));

var _MenuPanel = _interopRequireDefault(require("./containers/MenuPanel"));

var _MessageDialog = _interopRequireDefault(require("./containers/MessageDialog"));

var _MapControl = _interopRequireDefault(require("./containers/MapControl"));

var _BreakpointService = require("./modules/BreakpointService");

var _mapActions = require("./actions/mapActions");

var _MobileInfoBox = _interopRequireDefault(require("./containers/MobileInfoBox"));

var _SplashScreen = _interopRequireDefault(require("./containers/SplashScreen"));

var _ErrorScreen = _interopRequireDefault(require("./containers/ErrorScreen"));

var _MapTypeToggle = _interopRequireDefault(require("./containers/MapTypeToggle"));

var _Report = _interopRequireDefault(require("./containers/Report"));

var _permissions = _interopRequireDefault(require("./config/permissions"));

var _layerConfig = _interopRequireDefault(require("./config/layerConfig"));

var _layerPermissionActions = require("./actions/layerPermissionActions");

var _visibilityConfig = _interopRequireDefault(require("./config/visibilityConfig"));

var _sc = require("./actions/sc4");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var App = function App(props) {
  var dispatch = (0, _reactRedux.useDispatch)();

  var onResize = _lodash.default.debounce(function () {
    var appDOMContainer = window.document.getElementById('map-app');
    var appWidth = appDOMContainer && appDOMContainer.offsetWidth || window.innerWidth;
    var breakpoint = (0, _BreakpointService.getNameByPixels)(appWidth);

    if (breakpoint) {
      dispatch({
        type: _mapActions.DEVICE_CHANGED,
        nextDevice: breakpoint
      });
    }
  }, 10);

  (0, _react.useEffect)(function () {
    dispatch((0, _sc.resetMetadataDirectory)());
    dispatch((0, _layerPermissionActions.setAllowedLayers)(_visibilityConfig.default.options.filter(function (e) {
      return _permissions.default[props.type].allowedLayerVisibility.includes(e.name);
    }).reduce(function (curr, prev) {
      return curr.concat(prev.layers);
    }, []).map(function (e) {
      return _layerConfig.default.find(function (f) {
        return f.layerName === e.layerName;
      });
    }).filter(function (e) {
      return e !== undefined;
    }), _objectSpread(_objectSpread({}, _visibilityConfig.default), {}, {
      options: _visibilityConfig.default.options.filter(function (e) {
        return _permissions.default[props.type].allowedLayerVisibility.includes(e.name);
      })
    }), props.type));
  }, [props.type, dispatch]);
  (0, _react.useEffect)(function () {
    window.addEventListener('resize', onResize);
    onResize();
    return function () {
      window.removeEventListener('resize', onResize);
    };
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "map-app",
    id: 'map-app'
  }, /*#__PURE__*/_react.default.createElement(_MapPanel.default, {
    initialMapLocation: props.initialMapLocation,
    userBounds: props.userBounds
  }), /*#__PURE__*/_react.default.createElement(_MenuHeader.default, null), /*#__PURE__*/_react.default.createElement(_MenuPanel.default, null), /*#__PURE__*/_react.default.createElement(_MapControl.default, null), /*#__PURE__*/_react.default.createElement(_InfoBox.default, null), /*#__PURE__*/_react.default.createElement(_MobileInfoBox.default, null), /*#__PURE__*/_react.default.createElement(_MessageDialog.default, null), /*#__PURE__*/_react.default.createElement(_SplashScreen.default, null), /*#__PURE__*/_react.default.createElement(_ErrorScreen.default, null), /*#__PURE__*/_react.default.createElement(_MapTypeToggle.default, null), /*#__PURE__*/_react.default.createElement(_Report.default, null));
};

exports.App = App;
App.propTypes = {
  type: _propTypes.default.any.isRequired,
  initialMapLocation: _propTypes.default.shape({
    zoom: _propTypes.default.number
  }),
  userBounds: _propTypes.default.string
};
var _default = App;
exports.default = _default;